import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;

export const WrappingCell = styled.span`
  display: inline-block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: normal;
`;

export const ActionButton = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #065fa6;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 6px 8px;
  cursor: pointer;

  &:hover {
    background: #ebf4ff;
  }

  & i {
    font-size: 14px;
  }
`;

export const DocumentLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 4px;
  color: #065fa6;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 6px 8px;
  text-decoration: none;

  &:hover {
    background: #ebf4ff;
  }

  & i {
    font-size: 14px;
  }
`;

export const ThemedDialog = styled(Dialog)`
  &.p-dialog {
    width: min(520px, calc(100vw - 32px));
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(24, 24, 24, 0.22);
  }

  & .p-dialog-content,
  & .p-dialog-header {
    background: #ffffff;
  }

  & .p-dialog-header {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 12px 12px 0 0;
    border-bottom: none;
    background: transparent;
  }

  & .p-dialog-content {
    padding: 32px;
  }

  & .p-dialog-header-icons button {
    color: #5a5959;
    width: auto;
    height: auto;
    padding: 8px;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    margin: 0;

    &:hover {
      background: transparent;
    }
  }
`;

export const DialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const DialogTitle = styled.h2`
  margin: 0;
  color: #181818;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;

export const DialogText = styled.p`
  margin: 0;
  color: #181818;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PrimaryDialogButton = styled.button`
  min-width: 112px;
  border: 1.5px solid #065fa6;
  border-radius: 6px;
  background: #065fa6;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 8px 20px;
  cursor: pointer;

  &:hover {
    border-color: #181818;
    background: #181818;
  }
`;
